import { register } from '../../../Utils'

const AccordionContainer = el => {
  const panels = el.querySelectorAll('[data-accordion-toggler]')
  const activeOnStart = el.dataset.activeOnStart !== '0' ? +el.dataset.activeOnStart : null
  let activePanel = null

  const getContentElement = container => container.nextElementSibling
  const getIcon = container => container.querySelector('[data-accordion-icon]')
  const getPrefixFor = element => element.dataset.accordionPrefix || ''

  const deactivatePanel = panel => {
    const panelPrefix = getPrefixFor(panel)
    const contentElement = getContentElement(panel)
    contentElement.classList.remove(panelPrefix + 'grid-rows-accordion-open')
    contentElement.classList.add(panelPrefix + 'grid-rows-accordion-closed')
    getIcon(panel).classList.remove(panelPrefix + 'is--rotated')
  }

  const activatePanel = panel => {
    const panelPrefix = getPrefixFor(panel)
    const contentElement = getContentElement(panel)
    contentElement.classList.remove(panelPrefix + 'grid-rows-accordion-closed')
    contentElement.classList.add(panelPrefix + 'grid-rows-accordion-open')
    getIcon(panel).classList.add(panelPrefix + 'is--rotated')
    activePanel = panel
  }

  const changePanel = targetPanel => {
    if (activePanel) {
      deactivatePanel(activePanel)
    }

    if (activePanel === targetPanel) {
      activePanel = null
      return
    }

    activatePanel(targetPanel)
  }

  panels.forEach(panel => panel.addEventListener('click', e => changePanel(e.currentTarget)))

  if (activeOnStart) {
    changePanel(panels[activeOnStart - 1])
  }
}

register('AccordionContainer', AccordionContainer)
